export default __webpack_public_path__ + "static/media/ebay.7d88c111.png";